var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data tw-px-2 tw-text-center tw-flex tw-items-center tw-justify-center tw-h-full"},[_c('h4',{staticClass:"tw-my-4 tw-text-lg tw-text-gray-500 tw-font-normal"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }